// 3rd Party
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { MarketingButton } from '../../../../../../common/styles/oc-styled-components';
import {
  createMatchAndResults,
  resetMatches,
} from '../../../../../../connect/actions';
import { RESULTS_PATH } from '../../../../../../containers/App/Routes';
import { getMatchResultsPageConfiguration } from '../../../../../funnel/components/Search/constants';
import { ALL_CONFIGURATIONS } from '../../../../../funnel/funnelConfigs';
import { getFunnelConfiguration } from '../../../../../funnel/storage/constants';
import { useFunnelStorage } from '../../../../../funnel/storage/Storage';
import { STEP_KEY } from '../../../../../funnel/utils';

import { InsuranceWarningContainer } from './styled-components';

// Components

export const InsuranceWarning = ({ insuranceProvider, insurancePlan }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const storage = useFunnelStorage();

  const [updatingInsurance, setUpdatingInsurance] = useState(false);

  const updateInsurance = () => {
    const insurance = {
      hasInsurance: 'Yes',
      providerId: insuranceProvider.id,
      provider: insuranceProvider.name,
      topProvider: insuranceProvider.isPopular,
      planId: insurancePlan?.id,
      plan: insurancePlan?.name,
    };
    storage.save(STEP_KEY.INSURANCE, insurance, !insurance.socialAssistance);
    setUpdatingInsurance(true);
  };

  useEffect(() => {
    if (!updatingInsurance) {
      return;
    }

    dispatch(resetMatches());
    dispatch(
      createMatchAndResults(
        storage.transform(),
        getFunnelConfiguration(storage, ALL_CONFIGURATIONS),
        getMatchResultsPageConfiguration(),
      ),
    );
    history.push(RESULTS_PATH);
  }, [updatingInsurance]);

  return (
    <InsuranceWarningContainer data-testid="insuranceWarning">
      <div>
        <div className="insurance-warning-line">
          This practice isn't in network with the selected insurance plan.{' '}
        </div>
        <div className="insurance-warning-line">
          You can modify your search to find a practice that accepts your
          insurance.
        </div>
      </div>
      <MarketingButton
        size="medium"
        data-testid="modify-insurance-button"
        onClick={updateInsurance}
        loading={false}
        margin="8px 0"
      >
        Modify Search
      </MarketingButton>
    </InsuranceWarningContainer>
  );
};

InsuranceWarning.propTypes = {
  insuranceProvider: PropTypes.object,
  insurancePlan: PropTypes.object,
};
